import { css } from '@emotion/react'
import { HTMLMotionProps, motion } from 'motion/react'
import { HTMLAttributes, ReactNode } from 'react'

export interface ListSectionProps
	extends Omit<HTMLMotionProps<'section'>, 'title'>,
		Omit<HTMLAttributes<HTMLDivElement>, keyof HTMLMotionProps<'section'>> {
	title: ReactNode
	children?: ReactNode
}

export default function ListSection({ title, children, ...props }: ListSectionProps) {
	return (
		<motion.section
			css={css`
				&:first-of-type {
					margin-top: 16px;
				}
				&:not(:last-child) {
					margin-bottom: 16px;
				}
			`}
			{...props}
		>
			<h2
				css={css`
					font-size: 14px;
					font-weight: 500;
					color: var(--tint-secondary, #808080);
					padding: 12px 0;
					margin: unset;
				`}
				className="title"
			>
				{title}
			</h2>
			<main>{children}</main>
		</motion.section>
	)
}
